import { Empty, Result } from "@pankod/refine-antd";

export const localeNoData = {
    emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />,
};

export const localeInvalid = (subTitle: string) => ({
    emptyText: <Result subTitle={subTitle} />,
});